import React, { useEffect } from 'react'
import { Card, CardContent, Typography, Box, TextField, Button, Stack, CircularProgress, Paper, Divider } from '@mui/material'
import SendIcon from '@mui/icons-material/Send'

const DescriptionConfigurator = ({ 
  prompt,
  setPrompt,
  handleSubmit,
  loading,
  conversation,
  messagesEndRef,
  scrollToBottom,
}) => {
  // Scroll to bottom when conversation changes
  useEffect(() => {
    scrollToBottom()
  }, [conversation, scrollToBottom])

  // Handle form submission
  const onSubmit = (e) => {
    e.preventDefault()
    handleSubmit(e)
  }

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Typography variant="h6" gutterBottom>
          Generate Job Descriptions
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Enter a prompt to generate job descriptions based on your configured preferences.
        </Typography>

        {/* Conversation display */}
        <Paper 
          variant="outlined" 
          sx={{ 
            flexGrow: 1, 
            overflow: 'auto', 
            p: 2, 
            mb: 2,
            backgroundColor: 'background.default',
            maxHeight: '300px'
          }}
        >
          <Stack spacing={2}>
            {conversation.map((message, index) => (
              <Box 
                key={index} 
                sx={{ 
                  display: 'flex', 
                  justifyContent: message.type === 'user' ? 'flex-end' : 'flex-start',
                  width: '100%'
                }}
              >
                <Box 
                  sx={{ 
                    maxWidth: '80%',
                    p: 1.5,
                    borderRadius: 2,
                    backgroundColor: message.type === 'user' ? 'primary.main' : 'grey.100',
                    color: message.type === 'user' ? 'white' : 'text.primary',
                    boxShadow: 1
                  }}
                >
                  <Typography variant="body2">
                    {message.content}
                  </Typography>
                </Box>
              </Box>
            ))}
            <div ref={messagesEndRef} />
          </Stack>
        </Paper>

        {/* Prompt input form */}
        <Box component="form" onSubmit={onSubmit} sx={{ mt: 'auto' }}>
          <Divider sx={{ mb: 2 }} />
          <Stack direction="row" spacing={1}>
            <TextField
              fullWidth
              placeholder="Describe the job positions you want to create..."
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              disabled={loading}
              multiline
              maxRows={3}
              sx={{ 
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2
                }
              }}
            />
            <Button
              type="submit"
              variant="contained"
              disabled={loading || !prompt.trim()}
              sx={{ 
                minWidth: '48px',
                height: '48px',
                borderRadius: 2
              }}
            >
              {loading ? <CircularProgress size={24} /> : <SendIcon />}
            </Button>
          </Stack>
        </Box>
      </CardContent>
    </Card>
  )
}

export default DescriptionConfigurator